<template>
  <span class="tooltip-container">
    <span role="status">
      <span v-if="showPopup" class="tooltip-bubble">
        <slot></slot>
      </span>
    </span>
    <button class="info-btn"
      @mouseover="showPopup = true"
      @mouseleave="showPopup = false"
      @focus="showPopup = true"
      @blur="showPopup = false">
      <span v-if="showPopup" class="caret"></span>
      <span aria-hidden="true">i</span>
      <span class="visually-hidden">More info</span>
    </button>
  </span>
</template>

<script>

export default {
  name: 'tooltip',
  props: {
    copy: {
      type: String
    }
  },
  data () {
    return {
      showPopup: false
    }
  }
}
</script>

<style scoped lang="stylus" src="./tooltip.styl" >
